import { useState } from "react";

export type DrawerHookResult<T> = {
  isOpen: boolean;
  openDrawer: (details?: T) => void;
  closeDrawer: () => void;
  drawerDetails?: T | null;
  setDrawerDetails: (details: T | null | undefined) => void;
};

export const DrawerStateDefault = {
  isOpen: false,
  openDrawer: () => null,
  closeDrawer: () => null,
  setDrawerDetails: () => null,
  drawerDetails: null,
};

export const useDrawerState = <T>(
  defaultIsOpen = false,
): DrawerHookResult<T> => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const [drawerDetails, setDrawerDetails] = useState<T | null>();

  const handleOpen = (details?: T) => {
    setIsOpen(true);

    if (details) {
      setDrawerDetails(details);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setDrawerDetails(null);
  };

  return {
    isOpen,
    drawerDetails,
    setDrawerDetails,
    openDrawer: handleOpen,
    closeDrawer: handleClose,
  };
};
